import { Imodel } from "./imodel";
import { NotifierService } from "../../services/notifierService/notifier.service";

export class BaseModel extends NotifierService implements Imodel {
	public initialize(data: any): void {}

	public update(): void {}
}
